import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { StationeryRequestService } from "../../../../../services/company-office/StationeryRequest.service";

export const useGetMyApprovals = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["stationery-request-my-approvals", currentUserName],
    queryFn: () => StationeryRequestService.getStationeryRequests(currentUserName, ""),
    refetchOnMount: "always",
  });

  return response;
};
